'use client'

import { useContext, useEffect, type ReactNode } from 'react'

import { HubVisitContext } from '@/hooks/client/hub-visit-context'

import { useGuideEligibility } from './use-guide-eligibility'

// Keep the route static and the guide unmounted until the server confirms
// both US geography and a non-bot BotID result.
export const UsVisitorsOnly = ({ children }: { children: ReactNode }) => {
  const eligible = useGuideEligibility()
  const visit = useContext(HubVisitContext)

  useEffect(() => {
    if (eligible) {
      visit?.sectionMounted()
    }
  }, [eligible, visit])

  return eligible ? children : null
}
